import * as React from 'react';
import { MortgageRateHikeBanner } from '../../components/MortgageRateHikeBanner';
import { setMortgageRateHikeBannerClosed } from './utils/cookie';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentJsonQuery } from '../../selectors/location';
import { trackBannerClick, trackBannerShow } from './tracking';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { closeMortgageRateHikeBanner } from '../../actions/mortgageRateHikeBanner';

export const MortgageRateHikeBannerContainer = () => {
  const dispatch = useDispatch();
  const jsonQuery = useSelector(getCurrentJsonQuery);

  const onBannerShown = React.useCallback(() => trackBannerShow(jsonQuery), [jsonQuery]);

  const handleClose = React.useCallback(() => {
    setMortgageRateHikeBannerClosed();
    dispatch(closeMortgageRateHikeBanner());
    trackBannerClick(jsonQuery);
  }, [dispatch, jsonQuery]);

  return (
    <ActionAfterViewObserver callback={onBannerShown} triggerOnce>
      <MortgageRateHikeBanner onClick={handleClose} />
    </ActionAfterViewObserver>
  );
};
